import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getTeams } from 'store/actions'; // Assuming this action fetches team data
import Cookies from 'js-cookie';

const CreateTeamUnAvailability = ({ visible, handleClose, initialData = '', onSubmit,teamId }) => {
    const [teamOptions, setTeamOptions] = useState([]);
    const [startDateTime, setStartDateTime] = useState('');
    const [endDateTime, setEndDateTime] = useState('');
    const [unavailabilityType, setUnavailabilityType] = useState('');
    const dispatch = useDispatch();
    const teams = useSelector(state => state.Team.teams); // Assuming state.Team.teams contains the team data

    const userId = JSON.parse(Cookies.get('authUser'))?.userId


    useEffect(() => {
        if (teams?.Data?.length > 0) {
            setTeamOptions(teams?.Data?.map(team => ({ value: team.teamId, label: team.teamName })));
        }
    }, [teams]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
      
        // Get the components of the date
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed, so add 1
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = '00'; // Set seconds to '00' as per the requested format
      
        // Return the formatted date string
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            teamId: initialData?.teamId || '',
            startDateTime: initialData?.startDateTime || '',
            endDateTime: initialData?.endDateTime || '',
            reason: initialData?.reason || '',
            unavailabilityType: initialData?.unavailabilityType || '',
        },
        validationSchema: Yup.object({
            startDateTime: Yup.string().required('Start Date and Time are required'),
            endDateTime: Yup.string().required('End Date and Time are required').test('is-later', 'End Date-time must be later than Start Date-time', function (value) {
                const { startDateTime } = this.parent;

                if (!startDateTime || !value) {
                    return true; // Skip validation if either date is missing (handled by required)
                }

                const startDateTime2 = new Date(startDateTime);
                const endDateTime = new Date(value);

                // Check if end date is after start date or if dates are the same but time is later
                return (
                    endDateTime > startDateTime2 ||
                    (startDateTime2.toDateString() === endDateTime.toDateString() &&
                        endDateTime.getTime() > startDateTime2.getTime())
                );
            }),
            reason: Yup.string().required('Reason is required'),
            unavailabilityType: Yup.string().required('Unavailability Type is required'),
        }),
        onSubmit: (values,{ resetForm }) => {
            if (initialData?.teamId) {
                onSubmit({
                    sp: 'usp_UpdateTeamUnavailability',
                    updatedBy: userId,
                    unavailabilityId:initialData?.unavailabilityId,
                    startDateTime:formatDate(values?.startDateTime),
                    endDateTime:formatDate(values?.endDateTime),
                    reason:values?.reason,
                    unavailabilityType:values?.unavailabilityType,
                    teamId:teamId
                });
                
            } else {
                onSubmit({
                    sp: 'usp_InsertTeamUnavailability',
                    createdBy: userId,
                    startDateTime:formatDate(values?.startDateTime),
                    endDateTime:formatDate(values?.endDateTime),
                    reason:values?.reason,
                    unavailabilityType:values?.unavailabilityType,
                    teamId:teamId
                });
            }
            resetForm();
            handleClose();
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };
    const unavailabilityTypes = [
        { value: 'vacation', label: 'Vacation' },
        { value: 'sick_leave', label: 'Sick Leave' },
        { value: 'personal_leave', label: 'Personal Leave' },
        { value: 'other', label: 'Other' },
    ];

    // Handle the change event of the select input
    const handleUnavailabilityTypeChange = (selectedOption) => {
        formik.setFieldValue('unavailabilityType', selectedOption ? selectedOption.value : '');
    };

  
    return (
        <Modal
            title={initialData ? 'Edit Unavailability' : 'Create New Unavailability'}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600}
            className="custom-modal-header custom-modal-fullscreen p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        {/* Team Selector */}
                        {/* <div className="col-md-12">
                            <label className="form-label fs-7">Team</label>
                            <Select
                                options={teamOptions}
                                value={teamOptions.find(option => option.value === formik.values.teamId)}
                                onChange={(option) => formik.setFieldValue('teamId', option.value)}
                                placeholder="Select a team"
                            />
                            {formik.touched.teamId && formik.errors.teamId && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.teamId}</span>
                            )}
                        </div> */}

                        {/* Start Date Time */}
                        <div className="col-md-6">
                            <label className="form-label fs-7">Start Date and Time</label> <span className='text-danger'>*</span>
                            <input
                                type="datetime-local"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                name="startDateTime"
                                value={formik.values.startDateTime}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.startDateTime && formik.errors.startDateTime && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.startDateTime}</span>
                            )}
                        </div>

                        {/* End Date Time */}
                        <div className="col-md-6">
                            <label className="form-label fs-7">End Date and Time</label> <span className='text-danger'>*</span>
                            <input
                                type="datetime-local"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                name="endDateTime"
                                value={formik.values.endDateTime}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.endDateTime && formik.errors.endDateTime && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.endDateTime}</span>
                            )}
                        </div>

                        {/* Reason */}
                        <div className="col-md-12">
                            <label className="form-label fs-7">Reason</label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter reason"
                                name="reason"
                                value={formik.values.reason}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.reason && formik.errors.reason && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.reason}</span>
                            )}
                        </div>

                        {/* Unavailability Type */}
                        <div className="col-md-12">
                <label className="form-label fs-7">Unavailability Type</label> <span className='text-danger'>*</span>
                <Select
                    name="unavailabilityType"
                    value={unavailabilityTypes.find(option => option.value === formik.values.unavailabilityType)}
                    onChange={handleUnavailabilityTypeChange}
                    options={unavailabilityTypes}
                    placeholder="Select unavailability type"
                    
                />
                {formik.touched.unavailabilityType && formik.errors.unavailabilityType && (
                    <span style={{ color: 'red' }} role="alert">{formik.errors.unavailabilityType}</span>
                )}
            </div>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? 'Update' : 'Add'}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

// CreateTeamUnAvailability.propTypes = {
//     visible: PropTypes.bool.isRequired,
//     handleClose: PropTypes.func.isRequired,
//     initialData: PropTypes.object,
//     onSubmit: PropTypes.func.isRequired,
// };

export default CreateTeamUnAvailability;
